import request from '@/utils/request'

// 获取医院列表
export function hospitalSelect(data) {
  return request({
    url: '/api/hospital',
    method: 'get',
    params: { ...data, pcReqFlag: true },
  })
}

// 分页查询挂号记录
export function reserve(data) {
  return request({
    url: '/api/order/reservePage',
    method: 'get',
    params: data
  })
}


// 获取医院个数
export function getTotalCount() {
  return request({
    url: '/api/hospital/totalCount',
    method: 'get'
  })
}

// 获取医院挂号配置
export function byHospId(data) {
  return request({
    url: '/api/register-config-table/byHospId/' + data,
    method: 'get'
  })
}


// 获取用户习惯
export function getUserinured(data) {
  return request({
    url: '/api/record/get/inured',
    method: 'get',
    params: data
  })
}

// 保存用户习惯
export function saveUserinured(data) {
  return request({
    url: '/api/record/save/inured',
    method: 'post',
    data
  })
}